export default "__VITE_ASSET__CT3AYrRv__"